import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import CategoryDropdown from '@/components/feature/CategoryDropdown';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <>
      {/* Why section */}
      <section id="about" className="bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {t('home.why.title')}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">{t('home.why.text')}</p>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section id="categories" className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
            <div className="max-w-xl">
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                {t('home.categories.title')}
              </h2>
              <p className="mt-3 text-base text-foreground-600">{t('home.categories.subtitle')}</p>
            </div>

            {/* Dropdown */}
            <div className="w-full max-w-xs">
              <CategoryDropdown variant="hero" label={t('home.hero.dropdownPlaceholder')} />
            </div>
          </div>

          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {categories.map((c) => (
              <a
                key={c.key}
                href={c.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all hover:-translate-y-0.5 hover:border-primary-300"
              >
                <div className="h-36 w-full overflow-hidden md:h-40">
                  <img
                    src={c.image}
                    alt={t(`categories.${c.key}`)}
                    title={`${t(`categories.${c.key}`)} - USFans Spreadsheet`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="flex items-center justify-between gap-2 px-3 py-3">
                  <span className="truncate text-sm font-semibold text-foreground-900">{t(`categories.${c.key}`)}</span>
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-background-50 text-foreground-400 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-up-line text-sm" />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}